export enum ModuleSyncActions {
  connectToWifi = 1,
  getModuleInfo = 2,
}
